interface ICookieParams {
  name: string
  days?: number
  expires?: Date
  path?: string
  session?: boolean
  value?: string
}

export const setCookie = ({ name, value, days, expires, path = '/', session = false }: ICookieParams) => {
  let calcExpires = ''
  if (expires) {
    calcExpires = `; expires=${expires.toUTCString()}`
  } else if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    calcExpires = `; expires=${date.toUTCString()}`
  }

  document.cookie = `${name}=${value}${session ? '' : calcExpires}; path=${path}`
}

export const getCookie = ({ name }: { name: string }) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return (parts.pop() as string).split(';').shift()
  }
}

export const deleteCookie = ({ name }: { name: string }) =>
  setCookie({
    name,
    value: '',
    days: -1
  })
